export const SET_VISITS = 'Set visits'
export const SET_MY_VISITS = 'Set practitioner visits'
export const DELETE_VISIT = 'Delete visits'
export const UPDATE_VISIT = 'Update visits'
export const ADD_VISIT_DATA = 'Add visit data'
export const SET_VISIT_DATA = 'Set visit data'
export const SET_VISITS_TOTAL = 'Set visits total'
export const SET_MY_VISITS_TOTAL = 'Set my visits total'
